export default __webpack_public_path__ + "static/media/cardNFT.31470d09.png";